import { findIssuer } from "../../lib/util";
import { useCallback } from "react";
import { useGetIssuersQuery } from "../../services/savvy";
export default function useFindIssuer() {
    var issuers = useGetIssuersQuery(undefined, {
        selectFromResult: function (_a) {
            var data = _a.data;
            return {
                issuers: data,
            };
        },
    }).issuers;
    return useCallback(function (issuer, options) {
        return findIssuer(issuer, issuers, options);
    }, [issuers]);
}
